module.exports = {
          srcSet: __webpack_public_path__ + "aeca27b96eb8b98b498aa434e960c964-64.png"+" 64w",
          images:[ {path: __webpack_public_path__ + "aeca27b96eb8b98b498aa434e960c964-64.png",width: 64,height: 64}],
          src: __webpack_public_path__ + "aeca27b96eb8b98b498aa434e960c964-64.png",
          toString:function(){return __webpack_public_path__ + "aeca27b96eb8b98b498aa434e960c964-64.png"},
          
          width: 64,
          height: 64
        }